import React from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import { loadDetachedPayments, detachedPaymentModal } from '../store/deal.store';
import { saveScrollPosition } from '@/store/scroll.store';
import { selectDealsPage } from '@/store/allaround.store';
import { PaymentsArea } from './PaymentsArea.jsx';
import RoleConfigFilter, { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import CommonPaymentsContainer from './CommonPaymentsContainer';
import DetachedPayment from './DetachedPayment';

class CommonPaymentsArea extends PaymentsArea {
  constructor(props) {
    super(props);
    this.onClosePayment = this.onClosePayment.bind(this);
  }

  onClosePayment() {
    this.props.detachedPaymentModal(false);
  }

  render() {
    return (
      <RoleConfigFilter permissions={['financesViewEditDelete', 'myPaymentsView', 'viewPayments']}>
        <div>
          <DetachedPayment show={this.props.showModal} onClose={this.onClosePayment} />
          <CommonPaymentsContainer
            payments={this.props.payments}
            pageSize={this.props.pageSize}
            currentPage={this.props.current}
            onPageChange={this.onPageChange}
            pageSizeOptions={['25', '50', '100']}
            paginationPanel={this.renderPaginationPanel}
            disabled={!validateRoleConfig(['financesViewEditDelete'])}
            mode="financial"
            isCommonPayments
          />
        </div>
      </RoleConfigFilter>
    );
  }
}

export default connect(
  (state) => ({
    payments: state.getIn(['data', 'deals', 'deal', 'payments'], new List()),
    scrollPositions: state.getIn(['scroll'], new Map()),
    pageSize: state.getIn(['allaround', 'dealsPageSize', 'payments'], 100),
    current: state.getIn(['allaround', 'dealsPage', 'payments'], 1),
    roles: state.getIn(['session', 'roles'], new List()),
    showModal: state.getIn(['data', 'deals', 'deal', 'showModal'], false),
    locationQuery: state.getIn(['routing', 'locationBeforeTransitions', 'query'], new Map()),
  }),
  (dispatch, props) => ({
    loadDealPayments() {
      loadDetachedPayments(dispatch);
    },
    detachedPaymentModal(value) {
      detachedPaymentModal(dispatch, value);
    },
    selectPage(pageNumber, pageSize) {
      selectDealsPage(dispatch, pageNumber, pageSize, 'payments');
    },
    saveScrollPosition(page = `payments${props.current}`,
      location = window.pageYOffset ? window.pageYOffset : 0) {
      saveScrollPosition(dispatch, page, location);
    },
  })
)(CommonPaymentsArea);
